<template>
	<div class="mg-b-20 mg-lg-b-25 mg-xl-b-30">
		<div v-if="loading">
			<spinner-component :loading="loading" />
		</div>

		<div v-if="error" class="tx-center tx-danger">
			{{ error }}
		</div>
		<div v-else class="row">
			<div class="col-12">
				<div v-if="!portfolio && !loading">
					<h5 class="tx-color-01 mg-b-5 tx-center">Empty.</h5>
					<p class="tx-color-03 tx-13 tx-center">No Portfolio available at the moment.</p>
				</div>

				<div v-if="portfolio">
					<div v-if="saved" class="alert alert-success alert-dismissible fade show shadow-sm" role="alert">
						Your portfolio changes have been saved!
						<button type="button" class="close" data-dismiss="alert" aria-label="Close">
							<span aria-hidden="true">×</span>
						</button>
					</div>

					<div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
						<div class="strategy">
							<h4 class="mg-b-0">
								<span>Portfolio: {{ portfolio.portfolio_type.name | placeholder }}</span>
								<span class="d-block tx-color-03 tx-sm-18">Porfolio ID: {{ portfolio.external_portfolio_id | placeholder }}</span>
							</h4>
						</div>
						<div class="-d-none d-md-block">
							<router-link class="btn btn-default pd-x-15 mg-l-5 shadow-sm" :to="{ name: 'requests.deposit' }">Add Funds</router-link>
							<router-link class="btn btn-primary pd-x-15 mg-l-5 shadow-sm" :to="{ name: 'requests.withdraw' }">Withdraw</router-link>
						</div>
					</div>

					<div class="accordion" id="performanceIndicators">
						<div class="card shadow-sm mg-b-20">
							<div class="card-header pd-t-20 d-sm-flex align-items-start justify-content-between bd-b-0 pd-b-0">
								<div>
									<h6 class="mg-b-5">
										<button
											class="btn btn-link"
											type="button"
											data-toggle="collapse"
											data-target="#collapsePerformanceIndicators"
											aria-expanded="true"
											aria-controls="collapsePerformanceIndicators"
										>
											Performance Indicators
										</button>
									</h6>
									<p class="tx-13 tx-color-03 mg-b-0"></p>
								</div>
							</div>
							<div id="collapsePerformanceIndicators" class="collapse show" data-parent="#performanceIndicators">
								<div class="card-body portfolio-performance pd-y-20">
									<div class="row">
										<div class="media col-md-4" :class="portfolio.portfolio_type_id === 2 ? 'col-md-4': 'col-md-6'">
											<div class="media-body">
												<h4 class="tx-20 tx-sm-18 tx-md-24 tx-normal mg-b-5">{{ portfolio.value | toCurrency(portfolio.currency) | placeholder }}</h4>
												<h6 class="text-muted tx-nowrap mg-b-5 mg-md-b-8">Portfolio Value</h6>
											</div>
										</div>
										<div v-if="portfolio.portfolio_type_id === 2" class="media col-md-4">
											<div class="media-body">
												<h4 class="tx-20 tx-sm-18 tx-md-24 tx-normal mg-b-5">{{ showPrice | toNumber('0,0.0000') | placeholder }}</h4>
												<h6 class="text-muted tx-nowrap mg-b-5 mg-md-b-8">Unit Price</h6>
											</div>
										</div>
										<div class="media col-md-4" :class="portfolio.portfolio_type_id === 2 ? 'col-md-4': 'col-md-6'">
											<div class="media-body">
												<h4 class="tx-20 tx-sm-18 tx-md-24 tx-normal mg-b-5">{{ portfolio.units | toNumber('0,0.0000') | placeholder }}</h4>
												<h6 class="text-muted tx-nowrap mg-b-5 mg-md-b-8">Total Units</h6>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="accordion" id="allocation">
						<div class="card shadow-sm mg-b-40">
							<div class="card-header pd-t-20 d-sm-flex align-items-start justify-content-between bd-b-0 pd-b-0">
								<div>
									<h6 class="mg-b-5">
										<button class="btn btn-link" type="button" data-toggle="collapse" data-target="#collapseAllocation" aria-expanded="true" aria-controls="collapseAllocation">
											Allocation
										</button>
									</h6>
									<p class="tx-13 tx-color-03 mg-b-0"></p>
								</div>
							</div>
							<div id="collapseAllocation" class="collapse show" data-parent="#allocation">
								<div class="card-body portfolio-allocation pd-y-30">
									<div class="row">
										<div class="col-md-5">
											<allocation-chart-component :portfolio-id="portfolio.external_portfolio_id" :portfolio-type="portfolio.portfolio_type.name"></allocation-chart-component>
										</div>
										<div class="col-md-7">
											<allocation-table-component :portfolio-id="portfolio.external_portfolio_id" :portfolio-type="portfolio.portfolio_type_id"></allocation-table-component>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="accordion" id="transactions">
						<div class="card shadow-sm mg-b-20">
							<div class="card-header pd-t-20 d-sm-flex align-items-start justify-content-between bd-b-0 pd-b-0">
								<div>
									<h6 class="mg-b-5">
										<button class="btn btn-link" type="button" data-toggle="collapse" data-target="#collapseTransactions" aria-expanded="true" aria-controls="collapseTransactions">
											Transactions
										</button>
									</h6>
									<p class="tx-13 tx-color-03 mg-b-0"></p>
								</div>
							</div>
							<div id="collapseTransactions" class="collapse show" data-parent="#transactions">
								<div class="card-body portfolio-transactions pd-y-20">
									<div class="row">
										<div class="col-12">
											<transactions-table-component
												:portfolio-id="portfolio.external_portfolio_id"
												:show-price="portfolio.portfolio_type_id !== 2"
												:show-units="portfolio.portfolio_type_id !== 2"
											></transactions-table-component>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.media-body {
	text-align: center;
}

@media (max-width: 425px) {
	.strategy {
		margin-bottom: 1rem;
	}

	.strategy h4 {
		font-size: 0.875rem;
		color: #7987a1;
	}

	.strategy h4 span {
		margin-top: 5px;
		display: block;
		font-size: 1.3125rem;
		font-weight: 500;
		line-height: 1.25;
		color: #0a0909;
	}

	.portfolio-summary {
		padding-top: 15px;
		padding-bottom: 15px;
	}

	.portfolio-performance,
	.portfolio-allocation,
	.portfolio-transactions {
		padding-top: 10px;
		padding-bottom: 0px;
	}

	.portfolio-heading,
	.media-body {
		text-align: left;
		margin-bottom: 1rem;
	}
}

.value .input-group-text {
	border-radius: 0rem;
	border-top-left-radius: 0.25rem;
	border-bottom-left-radius: 0.25rem;
	min-height: 2.3rem;
	/* background: url("data:image/svg+xml,%3csvg xmlns=http://www.w3.org/2000/svg viewBox=0 0 4 5%3e%3cpath fill=%233b4863 d=M2 0L0 2h4zm0 5L0 3h4z/%3e%3c/svg%3e")
			no-repeat right 0.625rem center/8px 10px; */
}
</style>

<script>
export default {
	mounted() {
		$('#edit-portfolio').on('hidden.bs.modal', (e) => {
			this.form.clear();
		});
	},
	data() {
		return {
			saved: false,
			refresh: false,
			loading: false,
			portfolio: null,
			error: null,
			form: new Form({
				portfolio_type_id: null,
				monthly_deposit: null,
				contribution_day: null,
				target_amount: null,
				target_date: null,
			}),
			portfolioIndicators: null,
			month_days: this.$store.getters.month_days,
		};
	},
	created() {
		this.fetchPortfolio();
	},
	computed: {
		isGhsDiscretionary() {
			if (this.portfolio) {
                return this.portfolio.portfolio_type_id === 1
			}
		},
        showPrice() {
			if (this.portfolio) {
                if (!this.isEmpty(this.portfolio.holdings)) {
                    const iclfHolding = this.portfolio.holdings.find((holding) => holding?.security === 'ICAMGH-F003')

                    return !_.isEmpty(iclfHolding) ?  iclfHolding.security_details.price.value : null
                }

                return null
			}
        }
	},
	watch: {
		$route: 'fetchPortfolio',
		portfolio: function (portfolio) {
			if (!_.isNil(portfolio)) {
				this.portfolioIndicators = this.portfolioPerformanceIndicators(portfolio.value, portfolio.target_amount);
			}
		},
		refresh: function (status) {
			if (status) {
				$('#edit-portfolio').modal('hide');
				this.fetchPortfolio();
			}
		},
	},
	methods: {
		changeCurrency(currency) {
			this.form.currency = currency;
		},
		filterPortfolio(type) {
			return _.filter(this.portfolio, { type: type });
		},
		fetchPortfolio() {
			this.error = this.portfolio = null;
			this.loading = true;

			axios
				.get(`/api/portfolio/${this.$route.params.portfolio}`)
				.then((response) => {
					const portfolio = response.data.data.portfolio;

					if (!_.isEmpty(portfolio)) {
						this.portfolio = portfolio;

						this.form.fill({
							portfolio_type_id: this.portfolio.portfolio_type.id,
							monthly_deposit: this.portfolio.monthly_deposit,
							contribution_day: this.portfolio.contribution_day,
							target_amount: this.portfolio.target_amount,
							target_date: this.portfolio.target_date,
						});
					}
				})
				.catch((error) => {
					this.error = error.toString();
				})
				.finally(() => {
					this.loading = this.refresh = false;
				});
		},
		savePortfolioChanges() {
			this.form.patch(`/api/portfolio/${this.$route.params.portfolio}`).then(({ data }) => {
				this.saved = this.refresh = true;
			});
		},
	},
};
</script>
